import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme';
import App from './App';
import { JoinProvider } from './context/JoinContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <ChakraProvider theme={theme}>
        <JoinProvider>
          <App />
        </JoinProvider>
      </ChakraProvider>
    </HashRouter>
  </React.StrictMode>
);
